import React from "react";
import "../styles/Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
    return (
        <footer className="footer">
            <p className="footer-text">&copy; {new Date().getFullYear()} Hundefriseur Scheyern </p>
            <div className="footer-links">
                <a
                    href="https://www.facebook.com/profile.php?id=61569314182698"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Besuche unsere Facebook Seite"
                >
                    Facebook
                </a>
                <Link
                    to="/impressum"
                    aria-label="Impresum öffnen"
                >
                    Impressum
                </Link>

                <Link
                    to="/datenschutz"
                    aria-label="Datenschutz öffnen"
                >
                    Datenschutzerklärung
                </Link>
            </div>
        </footer>
    );
};

export default Footer;
